<template>
  <div>
    <!-- ##### ToolBar ##### -->
    <v-toolbar 
      :flat="scrollY == 0 && isMobile" 
      app> 
      <v-toolbar-title>Gestion des tournées</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn 
        :loading="loading"
        :disabled="loading"
        icon 
        @click="getTournees()">
          <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn 
        @click="NDvisible = !NDvisible"
        icon>
        <v-icon>settings</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- ##### Contenu ##### -->
    <v-content v-scroll="onScroll">
      <v-container :pa-0="isMobile">
        <v-layout wrap>
          <v-flex xs12 md6 :px-2="!isMobile">
            <CardPlus>
              <TourneesList
                title="Tournée du jour"
                typeVisu="aujourdhui">
                <v-alert slot="no-data" :value="true" color="info" icon="info" outline class="mx-2">
                  Aucune tournée prévue pour aujourd'hui
                </v-alert>
              </TourneesList>
              <TourneesList
                title="Prochaines tournées"
                typeVisu="suivante">
                <v-alert slot="no-data" :value="true" color="info" icon="info" outline class="mx-2">
                  Pas de prochaines tournées de prévues
                </v-alert>
              </TourneesList>
            </CardPlus>
          </v-flex>
          <v-flex xs12 md6 :px-2="!isMobile">
            <CardPlus>
              <TourneesList
                title="Liste des tournées">
                <v-alert slot="no-data" :value="true" color="info" icon="info" outline class="mx-2">
                  Aucune tournée disponible
                </v-alert>
              </TourneesList>
            </CardPlus>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <!-- ##### Barre des paramètres ##### -->
    <v-navigation-drawer right app v-model="NDvisible">
      <v-container fill-height>
        <v-layout justify-space-between column fill-height>
          <TourneesFilters/>
          <Parametres/>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { VNavigationDrawer } from 'vuetify/lib'
import { mapState, mapActions } from 'vuex'
import { TOURNEES_ACTION } from '@/store'
import TourneesList from '@/components/TourneesList'
import TourneesFilters from '@/components/TourneesFilters'
import Parametres from '@/components/Parametres'
import CardPlus from '@/components/CardPlus'

export default {
  components: {
    VNavigationDrawer,
    TourneesList,
    TourneesFilters,
    Parametres,
    CardPlus
  },
  data: () => ({
    scrollY : 0,
    NDvisible: false
  }),
  created(){
    this.NDvisible = ["xs","sm","md"].indexOf(this.$vuetify.breakpoint.name) == -1
  },
  mounted(){
    if(!this.tournees.length){
      this.getTournees()
    }
  },
  computed: {
    ...mapState(['loading', 'tournees'])
  },
  methods: {
    onScroll(){
      this.scrollY = window.scrollY
    },
    ...mapActions({
      getTournees : TOURNEES_ACTION
    })
  }
}
</script>


